import { render } from "./last-name-field.vue?vue&type=template&id=1aa7d4e2"
import script from "./last-name-field.vue?vue&type=script&lang=js"
export * from "./last-name-field.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__